<template>
  <div id="addstep" class="pb30">
    <Breadcrumb />
    <div class="font14">
      <p class="sub-title prl70 mt20">Configuration</p>
      <div class="content middle collect mb50">
        <div class="container configuration">
          <div class="row">
            <div class="col-xs-2">Artwork Name</div>
            <div class="col-xs-4">
              <el-input
                v-model="$store.state.artwork.name"
                placeholder
              ></el-input>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-2">Communication Protocol</div>
            <div class="col-xs-4">
              <el-radio
                v-model="$store.state.artwork.protocol"
                v-for="item in protocols"
                :key="item.value"
                :label="item.value"
              >
                {{ item.label }}
              </el-radio>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-2">Product Line</div>
            <div class="col-xs-6">
              <el-radio
                v-model="$store.state.artwork.productLine"
                v-for="item in productLines[$store.state.artwork.type]"
                :key="item.value"
                :value="item.value"
                :label="item.value"
              >
                {{ item.label }}
              </el-radio>
              <span v-if="$store.state.artwork.productLine == 'Classic'"
                >* Only White LED and No Sensors</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="nav-footer white font16">
      <span class="white click inlineb w10" @click="restart()">
        <i class="iconfont3 icon-reset"></i> RESTART
      </span>
      <span class="white click inlineb w10" @click="back()">
        <i class="iconfont3 icon-back"></i> BACK
      </span>

      <span class="orange click inlineb w10" @click="next()">
        NEXT <i class="iconfont3 icon-next"></i>
      </span>
    </div>
  </div>
</template>

<script>
import "@/assets/css/project.css";
import artworkToProductMixin from "../../mixins/artworkToProductMixin";
import Breadcrumb from "./Panel/Breadcrumb";

var productLines = [
  {
    label: "Signature",
    value: "Signature",
  },
  {
    label: "Classic (*)",
    value: "Classic",
  },
];

export default {
  name: "s7",
  mixins: [artworkToProductMixin],
  components: {
    Breadcrumb,
  },
  data() {
    return {
      productLines: {
        blackjack: [
          {
            label: "Signature",
            value: "Signature",
          },
        ],
        alba: productLines,
        aria: productLines,
        axes: this.hasClassic()
          ? productLines
          : [
              {
                label: "Signature",
                value: "Signature",
              },
            ],
      },
      protocols: [
        {
          label: "Crestron",
          value: "Crestron",
        },
        {
          label: "KNX",
          value: "KNX",
        },
        {
          label: "RS485",
          value: "RS485",
        },
      ],
    };
  },
  methods: {
    hasClassic() {
      if (
        this.$store.state.artwork.layout == "L9" ||
        this.$store.state.artwork.layout == "TT" ||
        this.$store.state.artwork.rightLayout == "L9" ||
        this.$store.state.artwork.rightLayout == "TT" ||
        this.$store.state.artwork.tripleRightLayout == "L9" ||
        this.$store.state.artwork.tripleRightLayout == "TT"
      ) {
        return true;
      }
      return false;
    },
    restart() {
      this.$confirm("Are you sure you want to restart?", "Warning", {
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        type: "warning",
      }).then(() => {
        this.$router.push({ path: "/collection" });
      });
    },
    back() {
      this.$store.commit("getProductCode");
      this.$router.push({
        path: "/collection/engraving/" + this.routeParamArtworkId,
      });
    },
    async next() {
      if (this.$store.state.artwork.protocol == "") {
        this.$message({
          type: "error",
          message: "Please Select Communication Protocol",
        });
        return;
      }
      this.$store.commit("getProductCode");
      this.$router.push({
        path: "/collection/preview/" + this.routeParamArtworkId,
      });
    },
  },

  created: function () {
    if (!this.$store.state.artwork.type) {
      alert("Please go to the start page");
      this.$router.push({ path: "/collection/" });
    }

    this.$parent.headerB();
    this.$parent.footerB();
    this.$parent.footerW();
    this.$store.state.current_step = 7;
  },
};
</script>

<style lang="css" scoped>
.nav-footer {
  border-top: 1px solid #ccc;
}
</style>
